import { Component } from '@angular/core';

@Component({
  selector: 'pb-not-found',
  template: `<h1>Component Not Found 404</h1>`
})
export class NotFoundComponent {

}



// WEBPACK FOOTER //
// ./src/app/components/common/not-found/not-found.component.ts